import React from "react";
import { useAuth } from "../../../usercontext";
import GlobalTranskript from "./globaltranskript";
import STopMenu from "../../../components/student/topmenu/topmenu";
import PageNotes from "../../pages/common/pagenotes";
import S911TopMenu from "../../student911/topmenu/topmenu";

export default function StudentTranskriptList() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent911 = profile?.role === "Student911"
  return (
    <>
      {!isStudent911 && <STopMenu slug={slug} activeMenu="TranskriptList" />}
      {isStudent911 && <S911TopMenu slug={slug} activeMenu="TranskriptList" />}
      <GlobalTranskript slug={slug} />
      <PageNotes
        type={"Student"}
        pageName={"StudentTranscriptPlanning"}
        studentId={slug}
      />
    </>
  );
}
